import Proptypes from 'prop-types'

const selectOptionType = Proptypes.shape({
  id: Proptypes.string.isRequired,
  label: Proptypes.string.isRequired,
  value: Proptypes.string.isRequired,
})

export default selectOptionType
